// extracted by mini-css-extract-plugin
export var downArrow = "_83-0";
export var label = "_83-1";
export var treatmentCard = "_83-3";
export var upArrow = "_83-2";